module.exports = __webpack_public_path__ + "static/powerbi-navigator-selected-3847b540667e760cc72c72db5e951fd1.png";